<template>
  <div class="block_top_menu w-100 align-items-stretch justify-content">
    <div
      v-for="category in sortedSubcategories"
      :key="category.uuid"
      class="d-flex section-wrapper"
      @mouseover="displayed = category.uuid"
      @mouseleave="displayed = undefined"
    >
      <b-link
        :to="categoryRoute(category)"
        :exact="!categoryRoute(category).params.listType"
        class="d-flex parent-category justify-content-center pt-3 pb-2 w-100"
      >
        <div class="d-flex section px-3 w-100">
          <span class="m-auto">{{ $tradukojTranslate(category.name) }}</span>
        </div>
      </b-link>
      <transition name="fade">
        <div
          v-if="displayed === category.uuid"
          ref="{{index}}_subcategories"
          class="submenu-container"
        >
          <div
            class="sub_categories"
            v-bind:style="{ maxHeight: submenuHeight(category.subcategories) }"
          >
            <div
              v-for="(subcategory, index) in category.subcategories"
              :key="subcategory.uuid"
              class="sub_category py-2"
              v-bind:class="{
                nofirstcolumn: !isInFirstColumn(
                  category.subcategories,
                  index + 1
                ),
              }"
            >
              <router-link
                :to="
                  subcategoryRoute(
                    subcategory,
                    category.department || category.uuid
                  )
                "
                class="sub_section"
              >
                {{ $tradukojTranslate(subcategory.name) }}
              </router-link>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <div class="d-flex section-wrapper">
      <b-link
        :to="{ name: 'services' }"
        class="d-flex parent-category justify-content-center pt-3 pb-2 w-100"
      >
        <div class="d-flex section px-3 w-100">
          <span class="m-auto">{{ $t("sections.services") }}</span>
        </div>
      </b-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    categories: Array,
  },
  data() {
    return {
      displayed: undefined,
    };
  },
  computed: {
    sortedSubcategories() {
      return this.categories.map(category => {
        category.subcategories = category.subcategories.sort((a, b) => {
          const s1 = this.$tradukojTranslate(a.name);
          const s2 = this.$tradukojTranslate(b.name);
          return s1.localeCompare(s2);
        });
        return category;
      });
    },
  },
  methods: {
    isInFirstColumn(subcategories, pos) {
      if (!subcategories) {
        return false;
      }
      if (pos <= 4) {
        return true;
      }
      var numel = subcategories.length;
      var len = Math.ceil(numel / 4);
      if (pos > len) {
        return false;
      }
      return true;
    },
    // premio para el que haga esto sólo con css
    submenuHeight(subcategories) {
      // cantidad de elementos
      var numel = subcategories.length;
      // cantidad de elementos entre 4 columnas
      var len = Math.ceil(numel / 4);
      // el numero de elementos en una columna por el alto que tienen
      // cada uno de ellos (34px) mas 40px de margen arriba y abajo que tiene
      // el contenedor (20 arriba, 20 abajo)
      return String(34 * len + 40) + "px";
    },
    categoryRoute(category) {
      return this.subcategoryRoute(
        category,
        category.department || category.uuid
      );
    },
    subcategoryRoute(category, department) {
      const route = {
        name: "product_list",
        params: {
          listType: department,
        },
        query: {
          categoryUuid: category.uuid,
        },
      };
      return route;
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        sections: {
          services: "Services",
          refund: "Refund",
          authorization: "Express Authorization",
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.block_top_menu {
  display: flex;
  background: $corp-color2;
  position: relative;

  .section-wrapper {
    box-sizing: border-box;
    flex-basis: 100px;
    flex-grow: 1;
    justify-content: center;
  }

  .parent-category {
    border-bottom: 3px solid transparent;

    &:hover,
    &.router-link-active {
      border-bottom: 3px solid $corp-color1;
      text-decoration: none;
    }
  }

  .section {
    font-size: $font-size-default;
    text-transform: uppercase;
    color: $white;
    line-height: $font-size-default;
    text-align: center;
    border-left: 1px solid #fff;
  }

  .submenu-container {
    position: absolute;
    background-color: white;
    z-index: 99999;
    top: 100%;
    left: 0;
    width: 100%;

    .sub_categories {
      flex-direction: column;
      display: flex;
      flex-wrap: wrap;
      /* max-height: 13rem; */
      align-content: flex-start;
      min-height: 13rem;
      padding: 20px 15px;

      .sub_category {
        width: 285px;

        a {
          text-transform: uppercase;
          font-weight: initial;
          color: #6f6f6f;
          font-size: 0.75rem;

          &:hover {
            color: #515151;
          }
        }
      }
    }
  }
}

.nofirstcolumn {
  border-left: 1px solid #ccc;
  a {
    padding-left: 10px;
  }
}

a.parent-category span:after {
  width: 100%;
  text-align: center;
  content: "";
  font-size: 7px;
  line-height: 7px;
  display: grid;
  font-family: "FontAwesome";
  margin-top: 0.3em;
}

.block_top_menu .section-wrapper:first-child .section {
  border-left: none;
}

.fade-enter-active {
  transition: opacity 0.2s;
}

.fade-leave-active {
  transition: opacity 0s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
